import { APPROACH } from "@/content";

export const Approach = () => (
  <section className="approach" id="como-funciona" data-testid="approach-section">
    <div className="wrap approach-grid">
      <div>
        <p className="eyebrow">{APPROACH.eyebrow}</p>
        <h2>{APPROACH.title}</h2>
        <p>{APPROACH.text}</p>
      </div>
      <div className="steps">
        {APPROACH.steps.map((step) => (
          <div className="step" key={step.title}>
            <strong>{step.title}</strong>
            <span>{step.text}</span>
          </div>
        ))}
        <a
          className="text-link"
          href={APPROACH.link.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="approach-cta-whatsapp"
        >
          {APPROACH.link.label}
        </a>
      </div>
    </div>
  </section>
);
